export default [
  '#7cb342', // green,
  '#039be5', // blue
  '#5e35b1', // purple
  '#e53935', // red
  '#ffb300' // orange
]



// WEBPACK FOOTER //
// ./src/lib/colors.js